<template>
    <mdb-container>
        <Vedheader>asdasd</Vedheader>
        <section class="mt-3">
            <mdb-row class="mb-3">
                <mdb-col>
                    <mdb-btn color="primary" v-on:click="gohome"><mdb-icon icon="chevron-left" class="mr-1"/> Retour à la liste des formations</mdb-btn>
                </mdb-col>
            </mdb-row>
            <mdb-alert color="danger" v-if="error" class="mt-3">
                {{ error }}
            </mdb-alert>
            <mdb-card class="card-body" style="margin-top: 1rem;" v-if="isLoading">
                <div class="d-flex justify-content-center">
                    <mdb-spinner big color="blue" />
                </div>
            </mdb-card>
            <mdb-row v-if="isloaded">
                <mdb-col md="8" class="mb-3">
                    <mdb-card reverse>
                        <mdb-card-header color="success-color-dark" v-if="iscompleted">Vous avez déjà complété cette formation!</mdb-card-header>
                        <mdb-view hover cascade>
                            <mdb-progress :value=videoprogress :height="2" color="danger" class="pb-0 mb-0" v-if="showvideo"></mdb-progress>
                            <video width="100%" autoplay v-if="showvideo">
                                <source :src="videofile" type="video/mp4">
                            </video>
                            <a v-on:click="startvideo" v-else>
                                <mdb-card-image :src="image" alt="Card image cap"></mdb-card-image>
                                <mdb-mask waves overlay="white-slight"></mdb-mask>
                            </a>
                        </mdb-view>

                        <mdb-btn-group v-if="showvideo" floating style="z-index: 4; display: initial; top: -35px;" class="text-center">
                            <mdb-btn color="primary" action floating class=" blue-gradient" size="lg" v-on:click="videobackward"><mdb-icon icon="backward" class="pr-1" /></mdb-btn>
                            <mdb-btn color="" action floating class=" purple-gradient" size="lg" v-on:click="playpause"><mdb-icon :icon="playerplaypause" :class="playerplaypauseclass" /></mdb-btn>
                            <mdb-btn color="primary" action floating class=" blue-gradient" size="lg" v-on:click="videoforward"><mdb-icon icon="forward" class="pl-1" /></mdb-btn>
                            <mdb-btn color="primary" action floating class=" blue-gradient" size="lg" v-on:click="dovideofullscreen"><mdb-icon icon="arrows-alt" class="pr-1" /></mdb-btn>
                        </mdb-btn-group>

                        <mdb-btn tag="a" floating action class="ml-auto mr-4 blue-gradient" size="lg" style="z-index: 4;" v-on:click="startvideo" v-if="!showvideo">
                            <mdb-icon icon="play" class="pl-1" />
                        </mdb-btn>
                        <mdb-card-body class="text-center" cascade style="margin-top:-2.1rem;">
                            <mdb-card-title><strong>{{title}}</strong></mdb-card-title>
                            <h5 class="indigo-text"><strong>{{catname}}</strong></h5>
                            <mdb-card-text class="text-justify">
                                {{introtext}}
                            </mdb-card-text>
                            <hr />
                            <mdb-card-text class="text-left">
                                <ul class="list-unstyled">
                                    <li>Durée: {{duration}}</li>
                                </ul>
                                <mdb-container v-if="canmarkascompleted && !iscompleted">
                                    <mdb-btn color="info" v-on:click="setascompleted">Cliquez ici si vous avez déjà complété cette formation.</mdb-btn>
                                </mdb-container>
                            </mdb-card-text>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
                <mdb-col md="4">
                    <mdb-card>
                        <mdb-card-header color="indigo lighten-1">Informations sur cette formation</mdb-card-header>
                        <mdb-card-body>
                            <mdb-card-title>Ressources supplémentaires</mdb-card-title>
                            <mdb-card-text>
                                <p v-if="documents.length">Voici quelques liens et fichiers pour accompagner cette formation</p>
                                <p v-else>Aucune ressources supplémentaire n'est disponible pour cette formation</p>
                                <mdb-list-group>
                                    <mdb-list-group-item tag="a" :href="item.link" target="_blank" v-for="item in documents" :key="item.ident">{{item.title}}</mdb-list-group-item>
                                </mdb-list-group>

                            </mdb-card-text>
                            <div v-if="hasquizz">
                                <hr/>
                                <mdb-card-title>Examen</mdb-card-title>
                                <mdb-card-text>Cette formation comporte un questionnaire final</mdb-card-text>
                                <mdb-btn color="blue">Accéder au questionnaire</mdb-btn>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
        </section>

        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>

        <mdb-container @hidden="playvideo">
            <mdb-modal :show="showStartVideoAtModal" @close="showStartVideoAtModal = false" info :removeBackdrop=false :cascade="true">
                <!--Header-->
                <mdb-modal-header :close="false">
                    <mdb-modal-title>Formation déjà démarrée</mdb-modal-title>
                </mdb-modal-header>
                <!--Body-->
                <mdb-modal-body  class="text-center">
                    <mdb-icon icon="info" size="4x" class="mb-3 animated rubberBand"/>
                    <p>Vous avez déjà commencé cette formation. Voulez vous continuer à l'endroit où vous étiez rendu?
                    </p>
                </mdb-modal-body>
                <!--Footer-->
                <mdb-modal-footer center>
                    <mdb-btn color="info" @click.native="playvideo('started')">Oui<mdb-icon icon="diamond" class="ml-1" color="white"/></mdb-btn>
                    <mdb-btn outline="info" @click.native="playvideo('beginning')">Non, démarrer du début </mdb-btn>
                </mdb-modal-footer>
            </mdb-modal>
        </mdb-container>
    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import {
        mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardHeader, mdbIcon, mdbBtn, mdbListGroup, mdbListGroupItem, mdbFooter, mdbMask, mdbView, mdbSpinner, mdbAlert,
        mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtnGroup, mdbProgress,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Videodetails',
        components: {
            Vedheader,
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCardHeader,
            mdbIcon,
            mdbBtn,
            mdbListGroup,
            mdbListGroupItem,
            mdbFooter,
            mdbMask,
            mdbView,
            mdbSpinner,
            mdbAlert,
            mdbModal,
            mdbModalHeader,
            mdbModalTitle,
            mdbModalBody,
            mdbModalFooter,
            mdbBtnGroup,
            mdbProgress,
        },
        data() {
            return {
                documents: [],
                duration: '',
                hasquizz: false,
                image: '',
                introtext: '',
                iscompleted: false,
                title: '',
                error: '',
                catname: '',
                isLoading: true,
                isloaded: false,
                showStartVideoAtModal: false,
                startat: 0,
                canstartat: 0,
                videofile: '',
                canmarkascompleted: false,
                showvideo: false,
                playcurrenttimestack: [],
                playerplaypause: 'pause',
                playerplaypauseclass: 'pr-1',
                videoplayerref: null,
                videoprogress: 0,
            };
        },
        mounted() {
            this.getFormationDetails();
        },
        methods: {
            getFormationDetails() {
                const api = new Apicall();
                const self = this;
                api.getVideoDetails(this.$route.params.videoident).then((response) => {
                    if (response.status === 'OK') {
                        self.document = response.data.documents;
                        self.duration = response.data.duration;
                        self.hasquizz = response.data.hasquizz;
                        self.image = response.data.image;
                        self.introtext = response.data.introtext;
                        self.iscompleted = response.data.iscompleted;
                        self.title = response.data.title;
                        self.catname = response.data.catname;
                        self.documents = response.data.documents;
                        self.error = '';
                        self.isloaded = true;
                        self.canmarkascompleted = response.data.canmarkascompleted;
                    } else {
                        self.error = response.msg;
                    }
                    self.isLoading = false;
                });
            },

            gohome() {
                this.$router.push({ name: 'Home' });
            },

            setascompleted() {
                const api = new Apicall();
                const self = this;
                api.setVideoAsCompleted(this.$route.params.videoident).then(() => {
                    self.getFormationDetails();
                });
            },

            startvideo() {
                const api = new Apicall();
                const self = this;
                api.getVideoContent(this.$route.params.videoident).then((response) => {
                    if (response.status === 'OK') {
                        self.canstartat = response.data.canstartat;
                        self.videofile = response.data.videofile;
                        if (self.canstartat > 0) {
                            self.showStartVideoAtModal = true;
                        } else {
                            self.playvideo();
                        }
                    } else {
                        self.error = response.msg;
                    }
                });
            },
            playvideo(mode = 'beginning') {
                if (mode === 'started') {
                    this.startat = this.canstartat;
                }
                this.showStartVideoAtModal = false;
                this.showvideo = true;
                const self = this;
                this.$nextTick().then(() => {
                    const videoplayer = document.getElementsByTagName('video')[0];
                    if (videoplayer) {
                        videoplayer.currentTime = this.startat;
                        self.videoplayerref = videoplayer;
                        // Add handle
                        self.videoplayerref.ontimeupdate = function () {
                            self.playerplaypause = 'pause';
                            self.playerplaypauseclass = 'pr-1';
                            self.trackVideoTime(videoplayer.currentTime);
                        };
                        self.videoplayerref.onended = function () {
                            self.playerplaypause = 'play';
                            self.playerplaypauseclass = 'pr-1';
                            self.sendvideotimestoserver();
                        };

                        self.videoplayerref.onpause = function () {
                            self.playerplaypause = 'play';
                            self.playerplaypauseclass = 'pl-1';
                            self.sendvideotimestoserver();
                        };
                    }
                });
            },

            trackVideoTime(currenttime) {
                this.playcurrenttimestack.push(currenttime);
                if (this.playcurrenttimestack.length > 20) {
                    this.sendvideotimestoserver();
                }
                this.videoprogress = (currenttime / this.videoplayerref.duration) * 100;
            },

            sendvideotimestoserver() {
                const api = new Apicall();
                api.pushVideoTimeTracking(this.$route.params.videoident, this.playcurrenttimestack);
                this.playcurrenttimestack = [];
            },

            playpause() {
                if (this.playerplaypause === 'play') {
                    this.videoplayerref.play();
                } else {
                    this.videoplayerref.pause();
                }
            },

            videobackward() {
                if (this.playerplaypause === 'pause') {
                    this.videoplayerref.currentTime -= 15;
                }
            },

            videoforward() {
                if (this.playerplaypause === 'pause') {
                    this.videoplayerref.currentTime += 15;
                }
            },

            dovideofullscreen() {
                if (this.videoplayerref.requestFullscreen) {
                    this.videoplayerref.requestFullscreen();
                } else if (this.videoplayerref.mozRequestFullScreen) { /* Firefox */
                    this.videoplayerref.mozRequestFullScreen();
                } else if (this.videoplayerref.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    this.videoplayerref.webkitRequestFullscreen();
                } else if (this.videoplayerref.msRequestFullscreen) { /* IE/Edge */
                    this.videoplayerref.msRequestFullscreen();
                }
            },
        },
    };
</script>
